/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  // Keep the Coming Soon button above Shop Pay installments.
  function moveComingSoonAboveShopPay() {
    const productBlock = document.querySelector('#cs-product-block');
    const appBlock = productBlock && productBlock.closest('.shopify-app-block');
    const shopPay = appBlock && appBlock.parentElement.querySelector(':scope > .shop-pay-terms');

    if (appBlock && shopPay && shopPay.previousElementSibling !== appBlock) {
      shopPay.before(appBlock);
    }
  }

  moveComingSoonAboveShopPay();

  const comingSoonOrderObserver = new MutationObserver(moveComingSoonAboveShopPay);
  comingSoonOrderObserver.observe(document.documentElement, { childList: true, subtree: true });



  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


(() => {
  const copy = {
    intro: 'The post length determines how much of the post extends through your piercing.',
    standard: 'Most common length, especially for younger lobes.',
    long: 'Provides an additional 2mm of length, giving you more room for thicker ear lobes (typically more common on adults) or temporary swelling.'
  };

  function closeAll(except) {
    document.querySelectorAll('.post-length-info__popover:not([hidden])').forEach((popover) => {
      if (popover === except) return;
      popover.hidden = true;
      popover.parentElement?.querySelector('.post-length-info__trigger')?.setAttribute('aria-expanded', 'false');
    });
  }

  function mountPostLengthInfo(root = document) {
    root.querySelectorAll('.lv-option-box[data-option-name="Post Length"] .lv-option-label').forEach((label, index) => {
      if (label.querySelector('.post-length-info')) return;

      const id = `post-length-info-${index}-${Math.random().toString(36).slice(2, 8)}`;
      const wrapper = document.createElement('div');
      wrapper.className = 'post-length-info';
      wrapper.innerHTML = `
        <button class="post-length-info__trigger" type="button"
          aria-label="About post lengths" aria-expanded="false" aria-controls="${id}">!</button>
        <div class="post-length-info__popover" id="${id}" role="dialog"
          aria-label="Post length information" hidden>
          <p>${copy.intro}</p>
          <p><strong>Standard Length - 9mm post:</strong> ${copy.standard}</p>
          <p><strong>Long Length - 11mm post:</strong> ${copy.long}</p>
        </div>`;

      label.appendChild(wrapper);
      const trigger = wrapper.querySelector('.post-length-info__trigger');
      const popover = wrapper.querySelector('.post-length-info__popover');

      trigger.addEventListener('click', (event) => {
        event.stopPropagation();
        const opening = popover.hidden;
        closeAll(opening ? popover : null);
        popover.hidden = !opening;
        trigger.setAttribute('aria-expanded', String(opening));
      });
      popover.addEventListener('click', (event) => event.stopPropagation());
    });
  }

  document.addEventListener('click', () => closeAll());
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });

  new MutationObserver(() => mountPostLengthInfo()).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountPostLengthInfo(), { once: true });
  } else {
    mountPostLengthInfo();
  }
})();



/* Move Post Length information into a viewport-safe overlay and add a close button */
(() => {
  function enhancePostLengthInfo() {
    document.querySelectorAll('.post-length-info__popover').forEach((popover) => {
      if (!popover.querySelector('.post-length-info__close')) {
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'post-length-info__close';
        close.setAttribute('aria-label', 'Close post length information');
        close.textContent = '×';
        close.addEventListener('click', (event) => {
          event.stopPropagation();
          popover.hidden = true;
          document.querySelector(`[aria-controls="${popover.id}"]`)?.setAttribute('aria-expanded', 'false');
        });
        popover.prepend(close);
      }
      if (popover.parentElement !== document.body) document.body.appendChild(popover);
    });
  }

  document.addEventListener('click', () => {
    setTimeout(() => {
      document.querySelectorAll('.post-length-info__trigger').forEach((trigger) => {
        const panel = document.getElementById(trigger.getAttribute('aria-controls'));
        trigger.setAttribute('aria-expanded', String(panel && !panel.hidden));
      });
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.post-length-info__trigger').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });
    }
  });

  new MutationObserver(enhancePostLengthInfo).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  enhancePostLengthInfo();
})();



/* Share standard-product Reviews.io ratings with linked long-post products */
(() => {
  function restoreLinkedProductReviews() {
    const snippets = document.querySelectorAll('.ruk_rating_snippet[data-sku$="LONGS"]');
    if (!snippets.length || document.documentElement.dataset.linkedReviewsRestored) return;

    snippets.forEach((snippet) => {
      snippet.setAttribute('data-sku', snippet.getAttribute('data-sku').replace(/LONGS$/, ''));
      ['data-pending', 'data-done', 'data-retrieved', 'rating-snippet-batch'].forEach((attribute) => {
        snippet.removeAttribute(attribute);
      });
      snippet.innerHTML = '';
      snippet.removeAttribute('aria-hidden');
    });

    const original = [...document.scripts].find((script) =>
      script.src.includes('rating-snippet/dist.js')
    );
    if (!original) return;

    document.documentElement.dataset.linkedReviewsRestored = 'true';
    const refresh = document.createElement('script');
    refresh.src = original.src + (original.src.includes('?') ? '&' : '?') + 'linked=' + Date.now();
    refresh.async = true;
    document.head.appendChild(refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreLinkedProductReviews, { once: true });
  } else {
    restoreLinkedProductReviews();
  }
})();



/* Reviews.io fallback for the Heart linked long-post product */
(() => {
  setTimeout(() => {
    const snippet = document.querySelector('.ruk_rating_snippet[data-sku="P1117S001G"]');
    if (!snippet || snippet.textContent.trim()) return;

    snippet.innerHTML =
      '<i aria-hidden="true" class="ruk-icon-percentage-star--100"></i>'.repeat(4) +
      '<i aria-hidden="true" class="ruk-icon-percentage-star--75"></i>' +
      '<span aria-hidden="true" class="ruk-rating-snippet-count" style="color:#333">(1936 Reviews)</span>';
    snippet.setAttribute('title', '4.73 Stars - 1936 Reviews');
    snippet.setAttribute('aria-label', '4.73 Stars - 1936 Reviews');
    snippet.setAttribute('role', 'button');
    snippet.setAttribute('tabindex', '0');
    snippet.style.color = '#ef433d';

    const openReviews = () => {
      const reviews = document.querySelector('[id^="ReviewsWidget-"], #reviews');
      reviews?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    snippet.addEventListener('click', openReviews);
    snippet.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openReviews();
      }
    });
  }, 4000);
})();



/* Keep Linked Options dropdown corners matched to the native variant dropdown */
(() => {
  function syncLinkedDropdownCorners() {
    document.querySelectorAll('.lv-option-dropdown').forEach((dropdown) => {
      const expanded = dropdown.getAttribute('aria-expanded') === 'true';
      dropdown.style.setProperty('border-bottom-left-radius', expanded ? '0' : '22px', 'important');
      dropdown.style.setProperty('border-bottom-right-radius', expanded ? '0' : '22px', 'important');
    });
  }

  new MutationObserver(syncLinkedDropdownCorners).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['aria-expanded']
  });
  syncLinkedDropdownCorners();
})();


/* Reserve space for the Linked Options Post Length menu while it is open. */
(() => {
  const optionSelector = '.lv-option-box[data-option-name="Post Length"]';

  function syncPostLengthDropdownSpace() {
    const option = document.querySelector(optionSelector);
    if (!option) return;

    const trigger = option.querySelector('.lv-option-dropdown[aria-expanded="true"]');
    const menu = document.querySelector('.lv-option-dropdown-options.show');

    if (trigger && menu) {
      option.style.setProperty('--post-length-menu-height', menu.getBoundingClientRect().height + 'px');
      option.classList.add('post-length-dropdown-open');
    } else {
      option.classList.remove('post-length-dropdown-open');
      option.style.removeProperty('--post-length-menu-height');
    }
  }

  new MutationObserver(syncPostLengthDropdownSpace).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
        attributeFilter: ['aria-expanded']
  });
  window.addEventListener('resize', syncPostLengthDropdownSpace);
  syncPostLengthDropdownSpace();
})();
(()=>{const u=()=>{if(!location.pathname.startsWith('/tools/bundle-subscriptions'))return;const h=document.querySelector('.bundleapp-login-block h2');if(h&&h.textContent.trim()==='Welcome')h.textContent='Welcome Subscription Member'};new MutationObserver(u).observe(document.documentElement,{childList:true,subtree:true});u()})();
(()=>{if(!location.pathname.includes('quarterly-earring-box-'))return;const u=()=>{const s=document.querySelector('.awtomic-sw__price-current--discounted'),c=document.querySelector('.awtomic-sw__price-compare'),p=document.querySelector('.product__price');if(s&&p){const v=s.textContent.trim(),o=c?c.textContent.trim():'';const h=o?'<span style="font-size:18px;font-weight:400;text-decoration:line-through;opacity:.65;margin-right:10px">'+o+'</span><span>'+v+'</span>':'<span>'+v+'</span>';if(p.innerHTML!==h)p.innerHTML=h;p.style.fontSize='32px';p.style.fontWeight='700';p.style.lineHeight='1.1';p.style.color='#536270'}};new MutationObserver(u).observe(document.documentElement,{childList:true,subtree:true,characterData:true});u()})();
(()=>{const u=()=>{document.querySelectorAll('.custom-newsletter p').forEach(p=>{if(p.textContent.trim().startsWith('Sign up for our newsletter'))p.textContent='Sign up for our newsletter and get 10% off'})};new MutationObserver(u).observe(document.documentElement,{childList:true,subtree:true});u()})();
